import PardakhtShakhsiGet from './Get'
import PardakhtShakhsiDetails from './Details'
import PardakhtShakhsiDirect from './Direct'
import PardakhtShakhsiCheckout from './Checkout'
import PardakhtShakhsiReceipt from './Receipt'

export {
    PardakhtShakhsiGet,
    PardakhtShakhsiDetails,
    PardakhtShakhsiDirect,
    PardakhtShakhsiCheckout,
    PardakhtShakhsiReceipt,
}